import { useRef } from "react";
import { toast } from "sonner";
import { Upload, FileDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";
import { errMsg } from "@/lib/format";

export const ImportButton = ({ entity, onDone }) => {
  const { api, t, download } = useApp();
  const ref = useRef();
  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post(`/import/${entity}`, fd);
      toast.success(`${data.created} créés · ${data.updated} mis à jour`);
      data.errors.slice(0, 5).forEach((er) => toast.warning(er));
      onDone?.();
    } catch (err) { toast.error(errMsg(err)); }
    e.target.value = "";
  };
  return (
    <>
      <input ref={ref} type="file" accept=".csv,.xlsx" hidden onChange={upload} data-testid={`import-file-${entity}`} />
      <Button variant="outline" onClick={() => ref.current.click()} data-testid={`import-btn-${entity}`}><Upload className="h-4 w-4 me-1" />{t("import")}</Button>
      <Button variant="ghost" size="sm" onClick={() => download(`/import/template/${entity}`, `modele_${entity}.csv`)} data-testid={`import-template-${entity}`}>
        <FileDown className="h-4 w-4 me-1" />CSV
      </Button>
    </>
  );
};
